function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  strokeDasharray: "1 8",
  d: "M0 .5h1120"
});

var SvgDottedLine = function SvgDottedLine(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 1120 1",
    fill: "none"
  }, props), _ref);
};

export default SvgDottedLine;